import deepEqual from '~/src/helpers/deepEqual'
import { CartProduct } from '~/src/types/CartProduct'

const getCartProductIndex = (cart: CartProduct[], cartProduct: CartProduct): number => (
  cart.findIndex((cp: CartProduct) => (
    cp.id === cartProduct.id
    && cp.is_coupon === cartProduct.is_coupon
    && cp.is_loyalty === cartProduct.is_loyalty
    && deepEqual(cp.modifierGroups, cartProduct.modifierGroups)
  ))
)

export {
  getCartProductIndex
}
